import { type } from '../utils/util';

export class AppConfigActions {
  static SET_PAGE = type('SET_PAGE');
  static SET_INTERNET_CONNECTION = type('SET_INTERNET_CONNECTION');
  static TOGGLE_OFFLINE_MODE = type('TOGGLE_OFFLINE_MODE');

  setPage(payload: { page: string }) {
    return {
      type: AppConfigActions.SET_PAGE,
      payload: payload
    };
  }

  setInternetConnection(payload: { connection: boolean }) {
    return {
      type: AppConfigActions.SET_INTERNET_CONNECTION,
      payload: payload
    };
  }

  public toggleOfflineMode() {
    return {
      type: AppConfigActions.TOGGLE_OFFLINE_MODE
    };
  }
}



// WEBPACK FOOTER //
// ./src/states/app/app-config.actions.ts